import type {DecorationPlugin} from '../types'
import {sortPlugin} from './sort'
import {textPlugin} from './text'
import {labelPlugin} from './label'
import {linkPlugin} from './link'
import {skinPlugin} from './skin'
import {stylePropertiesPlugin} from './styleProperties'
import {wPhotoPlugin} from './wphoto'
import {vectorImagePlugin} from './vectorImage'
import {imageXPlugin} from './imagex'
import {versionPlugin} from './version'
import {variantsPlugin} from './variants'

export const decorationPlugins: DecorationPlugin[] = [
    versionPlugin,
    stylePropertiesPlugin,
    linkPlugin,
    labelPlugin,
    imageXPlugin,
    wPhotoPlugin,
    textPlugin,
    skinPlugin,
    vectorImagePlugin,
    variantsPlugin,
    sortPlugin
]
